import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/dynamic-pdf-templates/by-pdf-template-id/{pdfTemplateId}']['GET'];

type Input = ThisApi['params'];
type Output = ThisApi['response'];

const getDynamicPdfTemplateAndAssetsByPdfTemplateId = async ({ pdfTemplateId }: Input): Promise<Output> => {
  try {
    const response = await formsBackendClient.get(`/dynamic-pdf-templates/by-pdf-template-id/${pdfTemplateId}`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch dynamic PDF templates by pdf template id:', error);
    throw error;
  }
};

export default getDynamicPdfTemplateAndAssetsByPdfTemplateId;
